import React from "react";
import { Link } from 'react-router-dom';
import Header from "./Header";
import './CompanyPages.css';

export default function ContactComplete() {
  return (
    <div className="home">
      <Header />
      <main className="wc-info">
        <div className="wc-info-container">
          <p className="wc-info-eyebrow">THANK YOU</p>
          <h1>お問い合わせを受け付けました</h1>
          <p className="wc-info-lead">ご相談いただき、ありがとうございます。<br />内容を確認し、担当者よりご連絡します。</p>
          <div className="wc-info-company-links"><Link to="/" className="wc-info-button">ホームへ戻る</Link></div>
        </div>
      </main>
    </div>
  );
}
